import { getOpenCatalogObjectiveIdParam, getSelfRegisteredQueryParam } from './openCatalogCourseFlow'

export const useIsFirstLoginAfterRegister = () => {
  const isSelfRegistered = getSelfRegisteredQueryParam()
  const objectiveIdParam = getOpenCatalogObjectiveIdParam()

  return isSelfRegistered && !objectiveIdParam
}
